export * from './BOC-trigger-initiation-configuration.component';